import { DistrictAPIResponse } from 'src/app/private/shared/types/responses/district-list.responses';
import { CoachDTO } from '../dtos/coach.dto';
import { DistrictDTO } from '../dtos/district.dto';
import { ProfileDTO } from '../dtos/profile.dto';
import { SchoolDTO } from '../dtos/school.dto';
import { State } from '../utilities/enums/state.enum';

export const MOCK_DISTRICT_RESPONSE: DistrictAPIResponse = {
  calendarBlocks: [],
  created_at: 1614787200,
  updated_at: 1614787200,
  data_contact_email: 'fake@district.isd',
  default_coach_timeline_id: 1,
  default_principal_timeline_id: 1,
  default_teacher_timeline_id: 1,
  id: 2,
  hubspot_company_id: '1234',
  district_code: 'engage2learn',
  is_b2b: 0,
  is_internal: 1,
  tenantId: 2,
  parentDistrictId: 0,
  title: 'engage2learn',
  address: '',
  address2: '',
  city: '',
  state: State.TX,
  zip: '',
  phone: '',
  domain: 'engage2learn.org',
  is_deleted: 0,
  logo: '/uploads/user_upload/202211/eSuiteLogoHorizontal.png',
  timezone: 'US/Central',
  counts: {
    users: 295,
    schools: 38,
  },
  schools: [],
  why: '',
  reporting_school_year: '2023-2024',
  default_private_logs: 0,
  users_can_login: 1,
  nightly_data_exports: 0,
  instructional_insights_export: 0,
};

export const MOCK_B2B_DISTRICT_RESPONSE: DistrictAPIResponse = {
  ...MOCK_DISTRICT_RESPONSE,
  is_b2b: 1,
};

export const MOCK_DISTRICT: DistrictDTO = {
  id: 2,
  hubspotCompanyId: '1234',
  districtCode: 'engage2learn',
  isB2b: 0,
  isInternal: 1,
  tenantId: 2,
  parentDistrictId: 0,
  title: 'engage2learn',
  address: '',
  address2: '',
  city: '',
  state: State.TX,
  zip: '',
  createdAt: 1614787200,
  updatedAt: 1614787200,
  phone: '',
  domain: 'engage2learn.org',
  isDeleted: 0,
  logo: '/uploads/user_upload/202211/eSuiteLogoHorizontal.png',
  timezone: 'US/Central',
  counts: {
    users: 295,
    schools: 38,
  },
  reportingSchoolYear: '2023-2024',
  defaultPrivateLogs: false,
  users_can_login: 1,
  nightlyDataExports: 0,
  instructionalInsightsExport: 0,
};

export const MOCK_SCHOOL: SchoolDTO = {
  id: 52,
  title: 'Engage Admin',
  address: '',
  address2: '',
  city: '',
  state: State.TX,
  zip: '',
  phone: '',
  counts: {
    users: 2,
  },
  district_id: MOCK_DISTRICT.id,
  isDeleted: 0,
};

export const MOCK_PROFILE: ProfileDTO = {
  id: 44406,
  first_name: 'Matt',
  last_name: 'Bachman',
  title: 'Chief Financial Officer',
  color: '#83e869',
  why: '',
  bio: '',
  website: '',
  created_at: 1614787200,
  facebook: '',
  twitter: '',
  instagram: '',
  googleplus: '',
  photo: '',
  youtube: '',
  photoUrl: '',
  is_influencer: 0,
  strongest_egrowe_standard_why: '',
  strongest_egrowe_standard_id: 0,
  weakest_egrowe_standard_why: '',
  weakest_egrowe_standard_id: 0,
};

export const MOCK_PROFILE_COACH: ProfileDTO = {
  created_at: 1614787200,
  id: 9,
  first_name: 'Shannon',
  last_name: 'Buerk',
  title: 'CEO, Engage! Learning',
  color: '#7619DA',
  why: 'I want every young person to realize the inherent creative genius inside and be able and willing to share it with the world!',
  bio: '<p>Shannon’s whole career has been about transformation. In her first teaching job, she helped four-time exit exam failures become successful on their Texas State Exit Exam and graduate. During her graduate work with Portland State University, she facilitated school districts in Oregon in forming action research teams to study and transform practice.</p>\n\n<p>When Shannon moved back to Texas in 1997, the state was undergoing vast changes by implementing a new set of curriculum standards, The Texas Essential Knowledge and Skills (TEKS). Shannon worked as an independent consultant with several districts across the state and with regional service centers to facilitate the curriculum transition as well as the transition to the new state standardized testing system, TAKS. Her background in the state standards is part of what makes Engage! such a viable partner for districts seeking to move to engaging and innovative instructional models while maintaining a focus on standards in this high-stakes, standardized testing era. Shannon is insistent that all of the Engage! training, curriculum writing facilitation, and coaching be grounded in a strong, standards-based model.</p>\n\n<p>After working as a curriculum alignment consultant, Shannon accepted a position as Assistant Superintendent for Curriculum and Instruction in Coppell ISD. In this position she facilitated the district wide implementation of professional learning communities, the creation of a choice high school and a successful high school restructuring effort including the initiation of career pathways utilizing the strategic planning process. In creating the choice high school, she facilitated groups of community members and staff over two years of planning processes that resulted in New Tech High @ Coppell, saving the district millions of dollars by coming up with an innovative educational solution to an overcrowding problem.</p>\n\n<p>Following her time in Coppell, Shannon worked as a consultant with Cambridge Strategic Services facilitating strategic planning in school districts nationwide. She also worked with architects and designers of Cambridge’s sister company, SHW Group, to design learning environments that support innovative learning platforms such as STEM, CTE, and project-based learning, including HD Woodson High School in Washington D.C. and a master plan for The Center for a Sustainable Future in Lenawee, Michigan. In addition, she worked with a national team across three companies in four states that partnered with students at Napa Valley New Tech High School to create a submission for the 21st Century Classroom Open Architecture Competition which merited a semi-finalist award. Her work with designers has also influenced the way Engage! works by integrating design thinking into their approach.</p>\n\n<p>Currently, Shannon is Chief Executive Officer of Engage! Learning Inc. Engage! works with educators and communities nationwide to strategically design and implement innovative learning solutions. To date, she has trained over 50,000 teachers and administrators, facilitated thousands of community members through the strategic design process and still works as an executive coach on select projects. Shannon is a regular speaker at national conferences including AASA, ASCD, NSPRA, ISTE, and their regional counterparts on topics related to the transformation of public education and innovative learning platforms. She is also currently facilitating the Region 10 Transformational Leadership Collaborative, a group of thirty superintendents working toward visionary change in education in Dallas, Texas.</p>\n',
  website: 'http://www.engage2learn.org',
  facebook: 'https://www.facebook.com/engage2learn',
  twitter: 'https://twitter.com/ShannonKBuerk',
  instagram: 'http://instagram.com/engage_learning',
  googleplus: 'https://plus.google.com/u/1/105241881125673819011/about',
  youtube: 'https://www.youtube.com/user/engage2learn',
  photoUrl: '',
  photo: '',
  is_influencer: 0,
  strongest_egrowe_standard_why: '',
  strongest_egrowe_standard_id: 104802,
  weakest_egrowe_standard_why: '',
  weakest_egrowe_standard_id: 104803,
};

export const MOCK_COACH: CoachDTO = {
  id: 9,
  username: 'shannon@engage2learn.org',
  email: 'shannon@engage2learn.org',
  status: 10,
  district_id: 2,
  school_id: 52,
  is_deleted: 0,
  coachee_type: 'teacher',
  years_coached: 2,
  is_smart: 0,
  profile: MOCK_PROFILE_COACH,
};
